import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { FormProvider, useForm } from "react-hook-form";
import { useTheme } from "@mui/material/styles";

import removeStep from "../../../../styles/svg/removeStep.svg";
import arrow from "../../../../styles/svg/arrow.svg";
import { deleteWorkflowStep } from "../../../../sevices/apiWorkflows";
import { RFHTextField, RHFSelect } from "../../../../components/RFH";
import CustomMenuItem from "../../../../components/Menu/CustomMenuItem";
import { CustomButton } from "../../../../components/Button/Button";
import { useCallback } from "react";
import useMutate from "../../../../hooks/useMutate";

function RemoveStep({
  showRemoveSteps,
  setShowRemoveSteps,
  currentStep,
  fields,
  close,
}) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const {
    handleSubmit: updateStepSubmit,
    watch,
    ...methods
  } = useForm();

  const { mutate: deleteWorkflowMutate } = useMutate(deleteWorkflowStep,
    ["adminWorkflow", "boards"],
    () => {},
    () => {
      close(false);
    });

  const handleClose = useCallback(() => {
    setShowRemoveSteps(false);
  }, [setShowRemoveSteps]);

  const handleRemoveWorkflowStep = useCallback((data) => {
    const { targetStep } = data;
    const selectedWorkflowStepId =
      targetStep ||
      (fields.length > 0
        ? fields.find(
            (item) => item.workflow_step_id !== currentStep.workflow_step_id
          )?.workflow_step_id
        : "");

    if (selectedWorkflowStepId) {
      deleteWorkflowMutate({
        workflow_step_id: currentStep.workflow_step_id,
        target_workflow_step_id: selectedWorkflowStepId,
      });
    }
  }, [deleteWorkflowMutate, currentStep.workflow_step_id, fields]);

  return (
    <React.Fragment>
      <Dialog
        fullScreen={fullScreen}
        open={showRemoveSteps}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        className="removeStepContainer"
        sx={{ height: "90vh" }}
        PaperProps={{
          sx: {
            borderRadius: "12px",
            maxHeight: "90vh",
            maxWidth: "500px",
          },
        }}>
        <DialogTitle id="responsive-dialog-title" className="removeStepdialog">
          <img src={removeStep} alt="" />
        </DialogTitle>
        <DialogContent className="content">
          <p className="content-heading">Remove Step</p>
          <DialogContentText>
            You are about to remove the step '{" "}
            <span className="content-span">{currentStep.status}</span>.' There
            are tasks assigned to this
            step. Please reassign these tasks to another step before proceeding.
          </DialogContentText>
        </DialogContent>
        <FormProvider {...methods}>
          <form onSubmit={updateStepSubmit(handleRemoveWorkflowStep)}>
            <DialogContent>
              <DialogContentText>
                <p className="ticket-reasign-step">Task Reassignment Step</p>
              </DialogContentText>

              <div className="ticket-reasign-step-container">
                <div className="initial-step">
                  <RFHTextField
                    name={"test"}
                    className="mui-status-field"
                    disabled
                    value={currentStep.status}
                  />
                </div>
                <img src={arrow} alt="" />
                <div className="initial-step">
                  <RHFSelect
                    className="mui-status-field"
                    required
                    id={`targetStep`}
                    name={`targetStep`}
                    defaultValue={
                      fields.length > 0
                        ? fields.filter(
                            (item) =>
                              item.workflow_step_id !==
                              currentStep.workflow_step_id
                          )[0]?.workflow_step_id
                        : ""
                    }>
                    {fields.length > 1 ? (
                      fields
                        .filter(
                          (item) =>
                            item.workflow_step_id !==
                            currentStep.workflow_step_id
                        )
                        .map((option) => (
                          <CustomMenuItem
                            key={option?.workflow_step_id}
                            id={`option.workflow_step_id`}
                            value={option.workflow_step_id}>
                            {option.status}
                          </CustomMenuItem>
                        ))
                    ) : (
                      <CustomMenuItem disabled value="">
                        No step to select
                      </CustomMenuItem>
                    )}
                  </RHFSelect>
                </div>
              </div>
            </DialogContent>

            <DialogActions
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}>
              <CustomButton
                className="remove-step-btn-save"
                autoFocus
                variant="contained"
                onClick={updateStepSubmit(handleRemoveWorkflowStep)}>
                <div className="btn-content">Update</div>
              </CustomButton>
              <CustomButton
                className="remove-step-btn-cancel"
                autoFocus
                variant="outlined"
                onClick={handleClose}>
                <div className="btn-content">Cancel</div>
              </CustomButton>
            </DialogActions>
          </form>
        </FormProvider>
      </Dialog>
    </React.Fragment>
  );
}

export default React.memo(RemoveStep);
